module.exports = __webpack_public_path__ + "img/partner7.cced0c1e.png";